import { call, put, takeLatest } from 'redux-saga/effects';
import ApiUtil from 'src/utils/ApiUtil';
import {
  getNewProgramFeesQueryFailedAction,
  getNewProgramFeesQuerySuccessAction,
  NEW_PROGRAM_FEES_QUERY_START,
  ADDITIONAL_NEW_PROGRAM_FEES_QUERY_START,
  UPDATE_NEW_PROGRAM_FEES_QUERY_START,
  NewProgramFeesQueryStartAction,
  NEW_PROGRAM_FEES_WITH_TAXES_QUERY_START,
  getNewProgramFeesWithTaxesQuerySuccessAction,
  getNewProgramFeesWithTaxesQueryFailedAction,
} from 'src/actions/NewProgramFeesQueryAction';

export function* getNewProgramFees(action: NewProgramFeesQueryStartAction) {
  try {
    let parameters;
    if (action.programParamMap != undefined) {
      parameters = {
        countryCode: action.countryCode,
        itemInfo: action.queryProduct,
        programIdList: action.programIdList,
        programParamMap: action.programParamMap,
        isTaxEnabled: action.isTaxEnabled,
      };
    } else {
      parameters = {
        countryCode: action.countryCode,
        itemInfo: action.queryProduct,
        programIdList: action.programIdList,
        isTaxEnabled: action.isTaxEnabled,
      };
    }
    // @ts-expect-error
    const response = yield call(
      ApiUtil.postApiWithTimeout,
      'getfeeswithnew',
      parameters,
    );
    if (response.succeed) {
      if (NEW_PROGRAM_FEES_WITH_TAXES_QUERY_START === action.type) {
        yield put(
          getNewProgramFeesWithTaxesQuerySuccessAction(
            action.programIdList,
            response.data,
          ),
        );
      } else {
        yield put(
          getNewProgramFeesQuerySuccessAction(
            action.programIdList,
            response.data,
          ),
        );
      }
    } else {
      if (NEW_PROGRAM_FEES_WITH_TAXES_QUERY_START === action.type) {
        yield put(
          getNewProgramFeesWithTaxesQueryFailedAction(action.programIdList),
        );
      } else {
        yield put(getNewProgramFeesQueryFailedAction(action.programIdList));
      }
    }
  } catch (error) {
    console.error('Call API getfeeswithnew error' + error);
    if (NEW_PROGRAM_FEES_WITH_TAXES_QUERY_START === action.type) {
      yield put(
        getNewProgramFeesWithTaxesQueryFailedAction(action.programIdList),
      );
    } else {
      yield put(getNewProgramFeesQueryFailedAction(action.programIdList));
    }
  }
}

export default function* newProgramFees() {
  yield takeLatest(
    [
      NEW_PROGRAM_FEES_WITH_TAXES_QUERY_START,
      NEW_PROGRAM_FEES_QUERY_START,
      ADDITIONAL_NEW_PROGRAM_FEES_QUERY_START,
      UPDATE_NEW_PROGRAM_FEES_QUERY_START,
    ],
    getNewProgramFees,
  );
}
